import { UserId } from '@business/entities/account';
import {
  ChecklistTemplateId,
  ChecklistTemplateResponse,
  CompactChecklistTemplateResponse,
  ChecklistStepResponse,
  ChecklistId,
} from '@business/entities/checklist';
import { TeamId } from '@business/entities/team';
import { Endpoint } from '../endpoint';

export function fetchTodoChecklists(parentId?: ChecklistId, onlyRecurring = false) {
  return Endpoint.get<CompactChecklistTemplateResponse[]>('@gc/todo-checklist', { params: { onlyRecurring, parentId: parentId ? parentId : 0 } });
}

export function fetchTodoChecklist(id: ChecklistTemplateId) {
  return Endpoint.get<ChecklistTemplateResponse>(`@gc/todo-checklist/checklist/${id}`);
}

export function createTodoChecklist(data: Partial<ChecklistTemplateResponse>) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/create`, { data });
}

export function updateTodoChecklist(id: ChecklistTemplateId, data: Partial<ChecklistTemplateResponse>) {
  return Endpoint.patch<ChecklistTemplateResponse>(`@gc/todo-checklist/${id}`, { data });
}

export function duplicateTodoChecklist(id: ChecklistTemplateId) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/duplicate/${id}`);
}

export function deleteTodoChecklist(id: ChecklistTemplateId) {
  return Endpoint.delete<void>(`@gc/todo-checklist/${id}`);
}

export function executeTodoChecklist(id: ChecklistTemplateId) {
  return Endpoint.post<void>(`@gc/todo-checklist/execute/${id}`);
}

/** Section **/
export function createChecklistSection(id: ChecklistTemplateId, name: string) {
  return Endpoint.post<void>(`@gc/todo-checklist/section/${id}`, { data: { name } });
}

export function updateChecklistSection(id: number, name: string) {
  return Endpoint.patch<void>(`@gc/todo-checklist/section/${id}`, { data: { name } });
}

export function deleteChecklistSection(id: number) {
  return Endpoint.delete<void>(`@gc/todo-checklist/section/${id}`);
}

export function sortSections(ids: number[]) {
  return Endpoint.post<void>(`@gc/todo-checklist/sort-section`, { data: { ids } });
}

/** Step **/
export function createChecklistStep(
  ChecklistTemplateId: ChecklistTemplateId,
  id: number,
  data: Partial<ChecklistStepResponse>,
  parentStepId?: number,
) {
  data = { ...data, ChecklistTemplateId, parentStepId };
  return Endpoint.post<void>(`@gc/todo-checklist/step/${id}`, { data });
}

export function updateChecklistStep(id: number, data: Partial<ChecklistStepResponse>) {
  return Endpoint.patch<void>(`@gc/todo-checklist/step/${id}`, { data });
}

export function deleteChecklistStep(id: number) {
  return Endpoint.delete<void>(`@gc/todo-checklist/step/${id}`);
}

export function sortSectionSteps(ids: number[]) {
  return Endpoint.post<void>(`@gc/todo-checklist/sort-step`, { data: { ids } });
}

export function updateAssignne(type: string, id: number | string, items: string[], assignSection?: boolean, assignStep?: boolean) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/assignee`, {
    data: { type, id, items, assignSection: assignSection || false, assignStep: assignStep || false },
  });
}

export function selectUserTeam(id: string, ids: string[], keepAssignee: boolean) {
  return Endpoint.post<void>(`@gc/todo-checklist/execute-assignees/${id}`, { data: { ids, keepAssignee } });
}

export function search(id: UserId | TeamId) {
  return Endpoint.get<CompactChecklistTemplateResponse[]>(`@gc/todo-checklist/search`, { params: { id } });
}

export function updateWatcher(type: string, id: number | string, items: string[]) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/watcher`, { data: { type, id, items } });
}

export function removeChecklistAssignees(id: ChecklistTemplateId) {
  return Endpoint.post<void>(`@gc/todo-checklist/remove-assignees/${id}`);
}

export function toggleStep(id: number, completeAll?: boolean) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/toggle/${id}`, { data: { completeAll } });
}

export function onAssigneeSelect(assigneeId: string, checklistId: ChecklistId, currentChecklistId: ChecklistId) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/todo-checklist/assignee-select`, { data: { assigneeId, checklistId, currentChecklistId } });
}
